<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <v-container style="min-width: 100% !important">
      <license-upload />
    </v-container>
  </div>
</template>

<script>
import LicenseUpload from "@/components/Definiciones/CargaDeLicencias/LicenseUpload.vue";
import LandingToolbar from "@/components/LandingToolbar/LandingToolbar.vue";
export default {
  components: { LicenseUpload, LandingToolbar },
};
</script>
